module.exports = __webpack_public_path__ + "static/beauty-box-checkout-mobile-0f9d54932896bc9cc1fba64a5cf56122.jpg";